var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},[_vm._l((_vm.tags),function([name, value],index){return _c('div',{key:index},[(
        value[0] &&
        ((value[0].values && value[0].values.length > 0) ||
          value[0].relative_date ||
          value[0].from)
      )?_c('filter-tag',_vm._g({attrs:{"name":name,"tag":_vm.getTags(value)}},_vm.$listeners)):_vm._e()],1)}),_c('span',{staticClass:"clear-filter",on:{"click":_vm.onClear}},[_vm._v("Clear Filter")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }